import PriorityMapping from './Priorities';

export default PriorityMapping;
